import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { DocumentType } from '../documents/types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { _mockDocumentType } from '../utils/documents.mock';

const getLoanDocDocumentTypeById: QueryFunction<
  DocumentType,
  ['/loan-document', string]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockDocumentType);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    document: { documentType: DocumentType };
  }>(`/documents/${queryKey[1]}?include=documentType`, {
    method: 'GET',
  });
  if (response.data && response.data.document.documentType) {
    return response.data.document.documentType;
  }
  throw new Error('Failed to fetch loan document by id');
};

export default getLoanDocDocumentTypeById;

export { _mockDocumentType };
